import { _ } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

const getOptions = (type: types.optimizer.RiskFactor['type'], riskModel: types.riskModel.RiskModel) => {
  if (type && riskModel) {
    const style = riskModel.definition?.style || [];
    const industry = riskModel.definition?.categories.find((c) => c.handle == 'industry')?.factors || [];

    if (type == 'STYLE') return [{ name: 'select-all', handle: 'select-all', theme: 'select-all' }, ...style];
    if (type == 'CATEGORY') return [{ name: 'select-all', handle: 'select-all', theme: 'select-all' }, ...industry];
    if (type == 'FACTOR')
      return _.uniqBy(
        [{ name: 'select-all', handle: 'select-all', theme: 'select-all' }, ...style, ...industry],
        'handle'
      );
  }

  return [];
};

export { getOptions };
